const projects =["intel","kp","optus","gigable","backtrace","docker","mashery","farmers","redbox","redboxinstant","smartinsure","google","googlecloud","vmware","kp_org"];
//const projects =["intel","kp"];

const fs = require('fs');
const sizeOf = require('image-size');


//var screenshots=[{id:28,imgsrc:"g1_splash.png"},{id:29,imgsrc:"g2_splash.png"}]
//var section = {name:"Overall Gigable UX and Visual Design",screenshots}
//var sections = [section]
//var projectJSON = {"Intel":{imgpath: "./images/screenshots",sections}}
var screenshots=[]
var projectJSON=[]
var sectionContent=null
var sections=[]

projects.forEach((project,index)=> {
var testFolder = './images/screenshots/'+project+'/';	
fs.readdirSync(testFolder).forEach((file,index) => {
	if(file !== ".DS_Store"){
		var dimensions = sizeOf(testFolder+file)
 		screenshots.push({id:index,imgsrc:file,width:dimensions.width,height:dimensions.height})
	}
})
sectionContent={"section":{name:"UX",screenshots}}
sections = [sectionContent]
projectJSON.push({[project]:{imgpath: "./images/screenshots/"+project+"/",sections}})
//console.log(JSON.stringify(projectJSON))
screenshots=[]
sectionContent =null
sections=[]
}) 

console.log(JSON.stringify(projectJSON));


fs.writeFile("output.json", JSON.stringify(projectJSON), 'utf8', function (err) {
    if (err) {
		console.log("An error occured while writing JSON Object to File.");
        return console.log(err);
    }

    console.log("JSON file has been saved.");
});

/* original code
const testFolder = './tests/';
const fs = require('fs');

fs.readdirSync(testFolder).forEach(file => {
  console.log(file);
})
*/



// WEBPACK FOOTER //
// ./src/ProcessScreenshotsToJSON.js